import React from 'react';
import { Box, Heading, Text, Flex } from '@chakra-ui/react';

export default function ApprovalHeader({ textColor }) {
  return (
    <Flex justify="space-between" align="center" mb="24px">
      <Box>
        <Heading size="md" color={textColor}>
          Approval Pengalihan Tiket
        </Heading>
        <Text fontSize="sm" color="gray.400" mt="4px">
          Daftar pengajuan transfer tugas tiket antar teknisi yang memerlukan persetujuan Admin.
        </Text>
      </Box>
    </Flex>
  );
}